import ADD_CHIPS_SOUND_URL from './sounds/sound_add_chips.mp3';
import ALL_IN_SOUND_URL from './sounds/sound_allin.mp3';
import BET_SOUND_URL from './sounds/sound_bet.mp3';
import BOMB_BEER_SOUND_URL from './sounds/sound_bomb_beer.mp3';
import BOMB_BOOM_1_SOUND_URL from './sounds/sound_bomb_boom5.mp3';
import BOMB_BOOM_2_SOUND_URL from './sounds/sound_bomb_boom6.mp3';
import BOMB_BOOM_3_SOUND_URL from './sounds/sound_bomb_boom7.mp3';
import BOMB_BOOM_4_SOUND_URL from './sounds/sound_bomb_boom8.mp3';
import BOMB_EGG_1_SOUND_URL from './sounds/sound_bomb_egg.mp3';
import BOMB_EGG_2_SOUND_URL from './sounds/sound_bomb_egg2.mp3';
import BOMB_FAIRY_SOUND_URL from './sounds/sound_bomb_fairy.mp3';
import BOMB_SHEEP_SOUND_URL from './sounds/sound_bomb_sheep.mp3';
import BOMB_THROW_SOUND_URL from './sounds/sound_bomb_throw.mp3';
import BOMB_SQUISH_1_SOUND_URL from './sounds/sound_bomb_tomato.mp3';
import BOMB_SQUISH_2_SOUND_URL from './sounds/sound_bomb_tomato2.mp3';
import BOMB_SQUISH_3_SOUND_URL from './sounds/sound_bomb_tomato3.mp3';
import CHAT_SOUND_URL from './sounds/sound_chat.mp3';
import CHECK_SOUND_URL from './sounds/sound_check.mp3';
import FLOP_SOUND_URL from './sounds/sound_flop.mp3';
import FOLD_SOUND_URL from './sounds/sound_fold.mp3';
import LOSE_SOUND_URL from './sounds/sound_lose.mp3';
import RAISE_SOUND_URL from './sounds/sound_raise.mp3';
import REVEAL_SOUND_URL from './sounds/sound_reveal.mp3';
import SHOWDOWN_SOUND_URL from './sounds/sound_showdown.mp3';
import SHUFFLE_SOUND_URL from './sounds/sound_shuffle.mp3';
import SIDE_BET_SOUND_URL from './sounds/sound_side_bet.mp3';
import TIME_RUNNING_OUT_SOUND_URL from './sounds/sound_time_running_out.mp3';
import WIN_SOUND_URL from './sounds/sound_win.mp3';
import YOUR_TURN_SOUND_URL from './sounds/sound_yourturn.mp3';
export const ALL_SOUND_ASSET_URLS = {
    shuffle: SHUFFLE_SOUND_URL,
    flop: FLOP_SOUND_URL,
    bet: BET_SOUND_URL,
    raise: RAISE_SOUND_URL,
    allin: ALL_IN_SOUND_URL,
    check: CHECK_SOUND_URL,
    fold: FOLD_SOUND_URL,
    yourturn: YOUR_TURN_SOUND_URL,
    win: WIN_SOUND_URL,
    lose: LOSE_SOUND_URL,
    showdown: SHOWDOWN_SOUND_URL,
    add_chips: ADD_CHIPS_SOUND_URL,
    reveal: REVEAL_SOUND_URL,
    chat: CHAT_SOUND_URL,
    time_running_out: TIME_RUNNING_OUT_SOUND_URL,
    beer: BOMB_BEER_SOUND_URL,
    boom1: BOMB_BOOM_1_SOUND_URL,
    boom2: BOMB_BOOM_2_SOUND_URL,
    boom3: BOMB_BOOM_3_SOUND_URL,
    boom4: BOMB_BOOM_4_SOUND_URL,
    egg1: BOMB_EGG_1_SOUND_URL,
    egg2: BOMB_EGG_2_SOUND_URL,
    fairy: BOMB_FAIRY_SOUND_URL,
    sheep: BOMB_SHEEP_SOUND_URL,
    squish1: BOMB_SQUISH_1_SOUND_URL,
    squish2: BOMB_SQUISH_2_SOUND_URL,
    squish3: BOMB_SQUISH_3_SOUND_URL,
    bomb_throw: BOMB_THROW_SOUND_URL,
    side_bet: SIDE_BET_SOUND_URL
};
